import React, { useEffect, useRef, useState } from "react";
import { EmptyFilterCondition, EmptyFilterConditionGroup, FCOperator, filterConditionOperators, getInitialFilterConditions, IFilterCondition, IFilterConditionEditorProps, IFilterConditionGroup, IFilterConditionGroupEditorProps, IFilterConditionsEditorProps, isValidInputValue, operatorHasRValue } from "./filter-condition-utils";
import classNames from "classnames";
import { Button, DropDownButton, Input, Select } from "uxp/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
import _, { last } from 'lodash'
import styles from './FilterConditionsEditor.module.scss';
import { CustomDropDownButton, ICustomDropdownButtonInstanceProps } from "@components/DropdownButton/DropdownButton";
import { DEPillInput } from "../PillInput/DEPillInput";


export const FilterConditionsEditor: React.FC<IFilterConditionsEditorProps> = (props) => {
    const { filterConditions, onChange, attributes, onChnageConfitions, query } = props

    const [conditions, setConditions] = useState(filterConditions)

    useEffect(() => {
        setConditions(filterConditions)
    }, [filterConditions])

    function addCondition() {
        const _fcs = _.cloneDeep(conditions)
        _fcs.Conditions.push(_.cloneDeep(EmptyFilterCondition))
        setConditions(_fcs)
        handleConditionChanges(_fcs)
    }

    function addConditionGroup() {
        const _fcs = _.cloneDeep(conditions)
        _fcs.Conditions.push(_.cloneDeep(EmptyFilterConditionGroup))
        setConditions(_fcs)
        handleConditionChanges(_fcs)
    }

    function updateCondition(updated: IFilterConditionGroup) {
        setConditions(updated)
        handleConditionChanges(updated)
    }

    function commitChanges() {
        onChange(conditions)
    }

    function handleConditionChanges(conds: IFilterConditionGroup) {
        onChnageConfitions(conds)
    }

    return <div className={classNames(styles.filterConditionsEditorContainer)}>

        <FilterConditionGroupEditor
            group={conditions}
            onChange={updateCondition}
            attributes={attributes}
            onRemove={() => { }}
            isParent={true}
            query={query}
        />

        <div className={styles.conditionsEditorFooter}>
            <div className={styles.left}>

                <div className={styles.addConditionButton} onClick={addCondition} >+ Add Condition</div>
                <div className={styles.addConditionButton} onClick={addConditionGroup} >+ Add Condition Group</div>
            </div>
            <div className={styles.right}>
                <Button
                    title="Apply"
                    onClick={commitChanges}
                    className="copilot-button"
                    icon="fas check-circle"
                />
            </div>
        </div>

    </div>
}

const FilterConditionGroupEditor: React.FC<IFilterConditionGroupEditorProps> = (props) => {
    const { group, onChange, onRemove, attributes, isParent, query } = props

    const dropdownRef = useRef<ICustomDropdownButtonInstanceProps>(null)

    function addCondition() {
        const _fcs = _.cloneDeep(group)
        _fcs.Conditions.push(_.cloneDeep(EmptyFilterCondition))
        onChange(_fcs)
        dropdownRef.current?.close?.()
    }

    function addConditionGroup() {
        const _fcs = _.cloneDeep(group)
        _fcs.Conditions.push(_.cloneDeep(EmptyFilterConditionGroup))
        onChange(_fcs)
        dropdownRef.current?.close?.()
    }

    function renderConditions() {

        function removeCondition(index: number) {
            const _group = _.cloneDeep(group)
            const filtered = _group.Conditions.filter((c, i) => i !== index)
            onChange({ ..._group, Conditions: filtered })
        }

        function updateCondition(index: number, condition: IFilterCondition | IFilterConditionGroup) {
            const _group = _.cloneDeep(group)
            const updated = _group.Conditions.map((c, i) => (i == index ? condition : c))
            onChange({ ..._group, Conditions: updated })
        }

        function renderLabel(index: number) {
            if (index == 0) return 'where'
            if (index == 1) return <Select
                selected={group.All ? 'and' : 'or'}
                onChange={s => onChange({ ..._.cloneDeep(group), All: s == 'and' })}
                options={[
                    { label: 'and', value: 'and' },
                    { label: 'or', value: 'or' },
                ]}
                className="lucy-query-engine-input-small"
                dropdownClassname="lucy-query-engine-dropdown"
            />
            if (index > 1) return group.All ? 'and' : 'or'
        }

        return <>{
            group.Conditions.map((c: (IFilterCondition | IFilterConditionGroup), i: number) => {

                const isGroup = c.hasOwnProperty('All')

                return (
                    <div className={styles.groupConditonContainer} key={i}>
                        <div className={styles.groupConditonLabel}> {renderLabel(i)} </div>
                        <div className={styles.groupConditon}>
                            {isGroup
                                ? <FilterConditionGroupEditor
                                    group={c as IFilterConditionGroup}
                                    onChange={(updated) => updateCondition(i, updated)}
                                    onRemove={() => removeCondition(i)}
                                    attributes={attributes}
                                    query={query}
                                />

                                : <FilterConditionEditor
                                    condition={c as IFilterCondition}
                                    onChange={(updated) => updateCondition(i, updated)}
                                    attributes={attributes}
                                    query={query}
                                />
                            }
                        </div>
                        {
                            isGroup ? null
                                : <div className={styles.groupConditonAction}>
                                    <div className={styles.actionButton} onClick={() => removeCondition(i)}>
                                        <FontAwesomeIcon icon={['fas', 'trash']} />
                                    </div>
                                </div>
                        }
                    </div>
                )
            })
        }</>
    }

    return <div className={classNames(styles.filterConditionGroupEditorContainer, { [styles.parent]: isParent })}>

        <div className={styles.groupHeader}>
            <div className={styles.groupTitle}>
                {
                    group.Conditions.length > 1
                        ? <>{group.All ? 'all ' : 'one '} of the conditions must be true </>
                        : null
                }
            </div>

            {
                isParent
                    ? null
                    : <div className={styles.groupActions}>
                        <CustomDropDownButton
                            ref={dropdownRef}
                            content={<>
                                <div className={styles.dropdownAddConditionButton} onClick={addCondition} >+ Add Condition</div>
                                <div className={styles.dropdownAddConditionButton} onClick={addConditionGroup} >+ Add Condition Group</div>
                            </>}
                        >
                            <div className={styles.actionButton}>
                                <FontAwesomeIcon icon={['fas', 'plus']} />
                            </div>
                        </CustomDropDownButton>

                        <div className={styles.actionButton} onClick={onRemove}>
                            <FontAwesomeIcon icon={['fas', 'trash']} />
                        </div>
                    </div>
            }
        </div>

        <div className={styles.groupBody}>
            {
                group.Conditions?.length > 0
                    ? <>{renderConditions()}</>
                    : <div className={styles.noConditionsMessageContainer}>No conditions added</div>
            }
        </div>
    </div>
}


const FilterConditionEditor: React.FC<IFilterConditionEditorProps> = (props) => {
    const { condition, onChange, attributes, query } = props
    const context = React.useContext(QueryBuilderContext)

    function renderInput() {
        const attr = attributes?.find(a => a.name == condition.Attribute)
        const dataType = attr?.type || 'text'

        function onValueChange(value: any) {
            onChange({ ...condition, Value: value })
        }

        function handleTypeChange(dType: string) {
            onChange({ ...condition, DataType: dType })
        }

        return <div className={styles.inputContainer}>

            {/* {(context && !!context?.renderCustomInput)
                ? <>{context.renderCustomInput(String(props.condition.Value), onValueChange)}</>
                :
                <div
                    className={classNames(
                        styles.customInputWithTransformation,
                        {
                            // [styles.typeError]: !isValidInputValue(props.condition.Value, props.condition.DataType)
                        }
                    )}
                >
                    <Input
                        placeholder='Value'
                        type='text'
                        value={String(props.condition.Value)}
                        onChange={onValueChange}
                        className={styles.filterConditionValueInput}
                    />

                    <div className={styles.typeInput}>
                        <Select
                            selected={props.condition.DataType || 'string'}
                            onChange={(v) => { handleTypeChange(v) }}
                            options={[
                                { label: 'abc', value: 'string' },
                                { label: '123', value: 'number' },
                                { label: 'T/F', value: 'boolean' },
                            ]}
                            className={'filter-conditions-value-type-input'}
                            dropdownClassname={'filter-conditions-value-type-input-dropdown'}
                        />
                    </div>
                </div>
            } */}

            <DEPillInput
                value={String(props.condition.Value)}
                onChange={onValueChange}
                query={query}
            />
        </div>
    }

    return <div className={styles.filterConditionEditorContainer}>
        <div className={styles.filterConditionInputContainer}>
            <Select
                selected={condition.Attribute || ''}
                onChange={s => onChange({ ...condition, Attribute: s })}
                options={attributes}
                labelField="name"
                valueField="name"
                className={"lucy-query-engine-input"}
                dropdownClassname="lucy-query-engine-dropdown"
            />
        </div>
        <div className={styles.filterConditionInputContainer}>
            <Select
                selected={condition.Operator || ''}
                onChange={s => onChange({ ...condition, Operator: s as FCOperator })}
                options={Object.values(filterConditionOperators)}
                className={"lucy-query-engine-input"}
                dropdownClassname="lucy-query-engine-dropdown"
            />
        </div>
        {operatorHasRValue(condition.Operator) ? (<div className={styles.filterConditionInputContainer}>
            {renderInput()}
        </div>) : null}
    </div>
}